import { createContext, useState, useContext } from "react";
import PopupContainer from "../components/PopupContainer";

interface PopupContextType {
    openPopup: (component: React.ComponentType, props?: any) => void;
    closePopup: () => void;
}

const PopupContext = createContext<PopupContextType | undefined>(undefined);

export const usePopup = () => useContext(PopupContext);

export const PopupContextProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [Component, setComponent] = useState(null);
    const [popupProps, setPopupProps] = useState({});

    const openPopup = (component, props = {}) => {
        setComponent(() => component);
        setPopupProps(props);
        setIsOpen(true);
    };

    const closePopup = () => setIsOpen(false);

    const contextValue: PopupContextType = {
        openPopup,
        closePopup,
    };

    return (
        <PopupContext.Provider value={contextValue}>
            {children}
            <PopupContainer
                isOpen={isOpen}
                onClose={closePopup}
                Component={Component}
                props={popupProps}
            />
        </PopupContext.Provider>
    );
};
